import { AchievementDefinition, BadgeDefinition, TitleDefinition } from '../types';

export const ACHIEVEMENTS: AchievementDefinition[] = [
  // INICIO
  {
    id: 'first_game',
    category: 'inicio',
    name: 'Primer paso',
    description: 'Jugar 1 partida',
    icon: 'Play',
    rarity: 'common',
    targetValue: 1,
    metricKey: 'gamesPlayed',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'debutante'
  },
  {
    id: 'first_win',
    category: 'inicio',
    name: 'Primera victoria',
    description: 'Ganar 1 partida',
    icon: 'Trophy',
    rarity: 'common',
    targetValue: 1,
    metricKey: 'wins',
    isHidden: false,
    repeatable: false
  },
  {
    id: 'first_robot_game',
    category: 'inicio',
    name: 'Primer rival virtual',
    description: 'Jugar 1 partida contra un rival virtual',
    icon: 'Cpu',
    rarity: 'common',
    targetValue: 1,
    metricKey: 'robotGames',
    isHidden: false,
    repeatable: false
  },

  // VICTORIAS
  {
    id: 'wins_5',
    category: 'victorias',
    name: 'Novato ganador',
    description: 'Ganar 5 partidas',
    icon: 'Medal',
    rarity: 'common',
    targetValue: 5,
    metricKey: 'wins',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'ganador'
  },
  {
    id: 'wins_100',
    category: 'victorias',
    name: 'Cien victorias',
    description: 'Ganar 100 partidas',
    icon: 'Crown',
    rarity: 'epic',
    targetValue: 100,
    metricKey: 'wins',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'veterano',
    rewardTitleId: 'veterano'
  },
  {
    id: 'streak_3',
    category: 'victorias',
    name: 'En racha',
    description: 'Ganar 3 seguidas',
    icon: 'Flame',
    rarity: 'rare',
    targetValue: 3,
    metricKey: 'streakBest',
    isHidden: false,
    repeatable: false
  },
  {
    id: 'streak_5',
    category: 'victorias',
    name: 'Imparable',
    description: 'Ganar 5 seguidas',
    icon: 'Zap',
    rarity: 'epic',
    targetValue: 5,
    metricKey: 'streakBest',
    isHidden: false,
    repeatable: false
  },

  // PUNTUACIÓN
  {
    id: 'move_50',
    category: 'puntuacion',
    name: 'Golpe de efecto',
    description: 'Hacer una jugada de 50+ puntos',
    icon: 'Target',
    rarity: 'rare',
    targetValue: 50,
    metricKey: 'bestWordScore',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'artillero'
  },
  {
    id: 'move_70',
    category: 'puntuacion',
    name: 'Jugada maestra',
    description: 'Hacer una jugada de 70+ puntos',
    icon: 'Star',
    rarity: 'epic',
    targetValue: 70,
    metricKey: 'bestWordScore',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'demoledor'
  },

  // PALABRAS
  {
    id: 'longest_word_7',
    category: 'palabras',
    name: 'Palabra larga',
    description: 'Jugar una palabra de 7 letras',
    icon: 'Type',
    rarity: 'common',
    targetValue: 7,
    metricKey: 'longestWordLength',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'constructor'
  },

  // Rivales virtuales
  {
    id: 'robot_axel',
    category: 'robots',
    name: 'Axel superado',
    description: 'Ganar una partida contra Axel',
    icon: 'ShieldCheck',
    rarity: 'rare',
    targetValue: 1,
    metricKey: 'robotWins_axel',
    isHidden: false,
    repeatable: false
  },
  {
    id: 'robot_nilo',
    category: 'robots',
    name: 'Nilo superado',
    description: 'Ganar una partida contra Nilo',
    icon: 'ShieldCheck',
    rarity: 'epic',
    targetValue: 1,
    metricKey: 'robotWins_nilo',
    isHidden: false,
    repeatable: false
  },
  {
    id: 'robot_orion',
    category: 'robots',
    name: 'Orion superado',
    description: 'Ganar una partida contra Orion',
    icon: 'ShieldCheck',
    rarity: 'legendary',
    targetValue: 1,
    metricKey: 'robotWins_orion',
    isHidden: false,
    repeatable: false
  },
  {
    id: 'robot_zenda',
    category: 'robots',
    name: 'Rival experto superado',
    description: 'Ganar una partida contra un rival virtual experto',
    icon: 'ShieldCheck',
    rarity: 'legendary',
    targetValue: 1,
    metricKey: 'robotWins_zenda',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'domador_ia'
  },

  // MODALIDADES
  {
    id: 'boards_3',
    category: 'modalidades',
    name: 'Explorador',
    description: 'Jugar en 3 tableros distintos',
    icon: 'Map',
    rarity: 'rare',
    targetValue: 3,
    metricKey: 'uniqueBoards',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'explorador'
  },
  {
    id: 'languages_2',
    category: 'modalidades',
    name: 'Bilingüe',
    description: 'Jugar partidas en 2 idiomas distintos',
    icon: 'Globe',
    rarity: 'rare',
    targetValue: 2,
    metricKey: 'uniqueLanguages',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'poliglota'
  },

  // CONSTANCIA
  {
    id: 'active_7_days',
    category: 'constancia',
    name: 'Una semana seguido',
    description: 'Jugar 7 días distintos consecutivos',
    icon: 'Calendar',
    rarity: 'rare',
    targetValue: 7,
    metricKey: 'daysActiveStreak',
    isHidden: false,
    repeatable: false,
    rewardBadgeId: 'constante'
  }
];

export const BADGES: BadgeDefinition[] = [
  { id: 'debutante', name: 'Debutante', description: 'Has dado tus primeros pasos en VerbO', icon: 'Play', category: 'inicio', unlockCondition: 'Jugar 1 partida' },
  { id: 'ganador', name: 'Ganador', description: 'Has demostrado que sabes ganar', icon: 'Medal', category: 'victorias', unlockCondition: 'Ganar 5 partidas' },
  { id: 'veterano', name: 'Veterano', description: 'Un jugador con mucha experiencia', icon: 'Crown', category: 'victorias', unlockCondition: 'Ganar 100 partidas' },
  { id: 'artillero', name: 'Artillero', description: 'Capaz de hacer jugadas potentes', icon: 'Target', category: 'puntuacion', unlockCondition: 'Jugada de 50+ puntos' },
  { id: 'demoledor', name: 'Demoledor', description: 'Tus jugadas son devastadoras', icon: 'Star', category: 'puntuacion', unlockCondition: 'Jugada de 70+ puntos' },
  { id: 'constructor', name: 'Constructor', description: 'Dominas la longitud de las palabras', icon: 'Type', category: 'palabras', unlockCondition: 'Palabra de 7 letras' },
  { id: 'explorador', name: 'Explorador', description: 'Has recorrido diversos tableros', icon: 'Map', category: 'modalidades', unlockCondition: 'Jugar en 3 tableros' },
  { id: 'poliglota', name: 'Políglota', description: 'Dominas el juego en varios idiomas', icon: 'Globe', category: 'modalidades', unlockCondition: 'Jugar en 2 idiomas' },
  { id: 'constante', name: 'Constante', description: 'Tu fidelidad al juego es admirable', icon: 'Calendar', category: 'constancia', unlockCondition: 'Jugar 7 días seguidos' },
  { id: 'domador_ia', name: 'Domador de IA', description: 'Has vencido a los rivales virtuales mas avanzados', icon: 'Cpu', category: 'robots', unlockCondition: 'Vencer a Orion o un rival experto' }
];

export const TITLES: TitleDefinition[] = [
  { id: 'debutante', name: 'Debutante', description: 'Acabas de empezar', unlockCondition: 'Jugar 1 partida', priority: 1 },
  { id: 'competidor', name: 'Competidor', description: 'Ya eres un rival serio', unlockCondition: 'Ganar 10 partidas', priority: 2 },
  { id: 'veterano', name: 'Veterano', description: 'Mucho recorrido a tus espaldas', unlockCondition: 'Ganar 100 partidas', priority: 3 },
  { id: 'maestro', name: 'Maestro del tablero', description: 'Dominio absoluto del juego', unlockCondition: 'Ganar 500 partidas', priority: 4 },
  { id: 'leyenda', name: 'Leyenda VerbO', description: 'El hito máximo', unlockCondition: 'Logro Leyenda VerbO', priority: 5 }
];
